import React, { useState } from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

const CustomDocModal = ({ onClose, onUpload }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [comment, setComment] = useState('');

  const handleFileChange = (event) => {
    onUpload(event, name, description, comment);
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Add document details</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          label='Document Name'
          type='text'
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          margin='dense'
          label='Description'
          type='text'
          fullWidth
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <TextField
          margin='dense'
          label='Comment (Optional)'
          type='text'
          fullWidth
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <input type='file' hidden onChange={handleFileChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button component='label' color='primary'>
          Upload
          <input type='file' hidden onChange={handleFileChange} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDocModal;
